import React, { useContext } from 'react';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useAppContext } from '../Context/AppContext';

const CategoryCard = ({ data }) => {

    const { BASE_PATH } = useContext(useAppContext);

    const {
        image,
        title,
        articleurl,
        categoryurl,
        categorytitle,
        postid
    } = data;
const isCelebrity = categoryurl === "celebrities";

const linkUrl = isCelebrity
  ? `/search/${encodeURIComponent(title)}`
  : `/${categoryurl}/${articleurl}`;

    // ✅ CLICK HANDLER
    const handleClick = () => {
        if (categoryurl === "photo-stories") {
            // 🔥 REDIRECT TO AMP (IMPORTANT)
            window.location.href = `/amp-story/${postid}/${articleurl}`;
        }
    };

    return (
        <Col lg={3} md={6} sm={6} xs={6} className='p-2'>
            <Card>

                {categoryurl === "photo-stories" ? (
                    // ✅ AMP STORY CLICK
                    <div onClick={handleClick} style={{ cursor: "pointer" }}>
                        <Card.Img src={image} alt={title} loading="lazy" />
                    </div>
                ) : (
                    // ✅ NORMAL ARTICLE
                    <Link to={linkUrl}>
                        <Card.Img src={image} alt={title} loading="lazy" />
                    </Link>
                )}

                <Card.Body>
                    <Card.Text className='card-category'>
                        {categorytitle}
                    </Card.Text>

                    {categoryurl === "photo-stories" ? (
                        <div onClick={handleClick} style={{ cursor: "pointer" }}>
                            <Card.Title className='word-line-limit'>
                                {title}
                            </Card.Title>
                        </div>
                    ) : (
                        <Link
                            to={linkUrl}
                            style={{ textDecoration: "none", color: "black" }}
                        >
                            <Card.Title className='word-line-limit'>
                                {title}
                            </Card.Title>
                        </Link>
                    )}
                </Card.Body>

            </Card>
        </Col>
    );
};

export default CategoryCard;